import {Col, Row} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {
    setFolderName,
    setScanName,
} from "../../../redux_actions/preview_status.action";
import {RegionSelectionConstants} from "../../../redux_constants/region_selection.constant";
import {
    C240SlideStatus, c240TaskType,
    cassetteType,
    objectiveType,
    progressStage, queueActions,
    scanSpeed,
    slideType,
    specimenType
} from '../../../utils/const';
import C240SlideView from './C240SlideView';
import SlideAreaSelectionComponent from './c240_preview_area_selection';
import '../../../asset/style/workflow/set-params.css';
import {updateEditorState} from '../../../redux_actions/c240_loader.action';
import SlideActionColumn from "../../../view/c240/C240SlideActionColumn";
import {
    appendToQueue,
    callScannerServer,
    comparePropsAndState,
    getDummyPreviewObject,
    getPreviewObject,
    getRackTrayFromCassetteKey, queueScan, updateQueueUIUtility
} from "../../../view/c240/utils";
import CassetteLevelActions from "./c240_cassette_level_actions";
import {getDeviceStatus} from "../../../redux_actions/device_status.action";
import {getC240Status} from "../../../redux_actions/c240_device_status.action";
import {isNull} from "../../../utils/utils";
let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BLOOD': specimenType.BLOOD,
    'BM': specimenType.BM
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

// let ALL_SLOTS_SELECTED = [true, true, true, true, true, true]
let ALL_SLOTS_UNSELECTED = [false, false, false, false, false, false];

const EmptyCassetteComponent = ({mySlideType, rack, tray}) => {

    return (
        <Col offset={mySlideType === slideType.SLIDE_2_BY_3_INCH ? 4 : 0} span={23}>
            <Row span={23} style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "90vh"
            }}>
                <Row style={{fontSize: "1.6vw"}}>No Cassette detected in selected slot
                    ({(rack === 0 ? "R" : "L") + (tray + 1)}).</Row>
                <Row style={{fontSize: "1vw"}}>Please select a slot with cassette to view loaded
                    slides.</Row>
            </Row>
        </Col>
    )
}

class SingleCassetteComponent extends Component {
    constructor(props) {
        super(props)
		let cassetteSizeArray = [];
		let cassetteSize = this.props.scannerProperties.cassetteSize;
		if (this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
			cassetteSize = this.props.scannerProperties.cassetteSize2by3;
		}
		for (let i = 0; i < cassetteSize; i++) {
			cassetteSizeArray.push(i);
		}
        this.state = {
            slideLoadingStatus: {},
            specimenType: this.getKeyByValue(SPECIMEN, this.props.scannerProperties.defaultConfig.specimenType),
            scanSpeed: this.getKeyByValue(SCAN_SPEED, this.props.scannerProperties.defaultConfig.scanSpeed),
            objectiveType: this.getKeyByValue(OBJECTIVE, this.props.scannerProperties.defaultConfig.objectiveType),
            expandedSlide: false, // is true when user clicked on slide to modify scan settings
            selectedSlots: ALL_SLOTS_UNSELECTED,
            slotIndexes: cassetteSizeArray,
            deviceId: this.props.deviceId,
            cassetteSize: this.props.scannerProperties.cassetteSize,
            selectedSlotIndex: -1,
            defaultConfig: this.props.scannerProperties.defaultConfig,
            maskForPathCacheBusterKey: (new Date()).getTime(), // used for busting cache (prevent loading cached image for same slot) of preview images
            barcodeVerify: false, // if true we use regex to validate slide name, if invalid Queue For Scan btn is disabled
        };
        this.slideElement = {
            0: React.createRef(),
            1: React.createRef(),
            2: React.createRef(),
            3: React.createRef(),
            4: React.createRef(),
            5: React.createRef(),
        }

        this.SlideType = this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES ?
            slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;
    }

    componentDidMount = () => {
        console.debug("busting mask for path image cache");

        //Make SpecimenTypes Config Based
        let supportedSpecs = this.props.supportedSpecimenTypes
        let specimens_ = []
        if (supportedSpecs != undefined && (supportedSpecs || {}).length > 0) {
            this.props.supportedSpecimenTypes.map((index) => {
                specimens_.push(index);
            })
        }

        Object.keys(SPECIMEN).map((specimen) => {
            if (specimen == "HE") {
                if (!(specimens_.includes("HNE_TISSUE"))) {
                    delete SPECIMEN[specimen]
                }
            } else if (!(specimens_.includes(specimen))) {
                delete SPECIMEN[specimen]
            }
        });

        this.setState({
            maskForPathCacheBusterKey: (new Date()).getTime(),
            barcodeVerify: this.props.verifyBarcode,
        });

        let slide_level_status = this.props.slideLevelScanPreviewStatus;
        let slides = this.state.slotIndexes.map((index) => {
            let slideKey = this.props.selectedCassette + "S" + index;
            let slide_name = (((slide_level_status || {})[slideKey] || {}).previewResponse || {}).slideName;
            let folder_name = (((slide_level_status || {})[slideKey] || {}).previewResponse || {}).folderName;
            this.props.dispatch(setScanName(index, slide_name))
            this.props.dispatch(setFolderName(index, folder_name))
        })
    }

    componentDidUpdate = (prevProps) => {

        // console.log("SingleCassetteView changes: ", getObjectDifference(prevProps, this.props));

		let cassetteSizeArray = [];
		let cassetteSize = this.props.scannerProperties.cassetteSize;
		if (this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES) {
			cassetteSize = this.props.scannerProperties.cassetteSize2by3;
		}
		for (let i = 0; i < cassetteSize; i++) {
			cassetteSizeArray.push(i);
		}
        if (this.state.slotIndexes.length != cassetteSizeArray.length) {
            this.setState({
                slotIndexes: cassetteSizeArray
            });
        }


        // re-enable queue preview btn
        let slide_level_status = this.props.slideLevelScanPreviewStatus;
        let prev_slide_level_status = prevProps.slideLevelScanPreviewStatus;
        // logic for changing cache busting key based on right conditions
        if (this.props.selectedCassette !== prevProps.selectedCassette) {
            let slides = this.state.slotIndexes.map((index) => {
                let slideKey = this.props.selectedCassette + "S" + index;
                let slide_name = (((slide_level_status || {})[slideKey] || {}).previewResponse || {}).slideName;
                let folder_name = (((slide_level_status || {})[slideKey] || {}).previewResponse || {}).folderName;
                this.props.dispatch(setScanName(index, slide_name));
                this.props.dispatch(setFolderName(index, folder_name));
            });
            this.setState({
                maskForPathCacheBusterKey: (new Date()).getTime(),
            });
        }
        if (this.props.barcodeCacheBustingKey !== prevProps.barcodeCacheBustingKey) {
            console.debug("change of barcode cache busting key, also busting mask for path cache key");
            this.setState({
                maskForPathCacheBusterKey: (new Date()).getTime(),
            });
        }

        this.state.slotIndexes.map((index) => {
            let state_of_slide = ((slide_level_status || {})[this.props.selectedCassette + "S" + String(index)] || {}).slideState;
            let prev_state_of_slide = ((prev_slide_level_status || {})[this.props.selectedCassette + "S" + String(index)] || {}).slideState;

            if (prev_state_of_slide !== C240SlideStatus.PREVIEW_DONE && state_of_slide === C240SlideStatus.PREVIEW_DONE) {
                let slideKey = this.props.selectedCassette + "S" + index;
                let slide_info = ((slide_level_status || {})[slideKey] || {}).previewResponse;
                const slide_name = (slide_info || {}).slideName;
                let folder_name = (slide_info || {}).folderName;
                this.props.dispatch(setScanName(index, slide_name));
                this.props.dispatch(setFolderName(index, folder_name));
            }
        });

        for (let slide_idx = 0; slide_idx < this.state.slotIndexes.length; slide_idx++) {
            const slide_key = `${this.props.selectedCassette}S${slide_idx}`;
            const single_slide_status = (slide_level_status || {})[slide_key];
            const slide_state = (single_slide_status || {}).slideState;
            const prev_slide_state = ((prev_slide_level_status || {})[slide_key] || {}).slideState;
            console.debug("slide_state is", slide_state, "prev_slide_state is", prev_slide_state);
            if (prev_slide_state === C240SlideStatus.INITIAL
                && slide_state !== C240SlideStatus.INITIAL) {
                console.debug("slide state changed from INITIAL, so busting mask for path cache key");
                this.setState({
                    maskForPathCacheBusterKey: (new Date()).getTime(),
                });
                this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }
            // enable preview btn every time we go to initial state
            if (prev_slide_state !== C240SlideStatus.INITIAL
                && slide_state === C240SlideStatus.INITIAL) {
                this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state === C240SlideStatus.PREVIEW_DONE
                && slide_state !== C240SlideStatus.PREVIEW_DONE) {
                this.props.enableQScanBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state !== C240SlideStatus.SCAN_CRASHED
                && slide_state === C240SlideStatus.SCAN_CRASHED) {
                this.props.enableQScanBtn(this.props.selectedCassette, slide_idx);
            }

            // enable preview on every scan crash
            if (prev_slide_state !== C240SlideStatus.SCAN_CRASHED
                && slide_state === C240SlideStatus.SCAN_CRASHED) {
                this.props.enablePreviewBtn(this.props.selectedCassette, slide_idx);
            }

            if (prev_slide_state !== C240SlideStatus.PREVIEW_DONE
                && slide_state === C240SlideStatus.PREVIEW_DONE) {
                console.debug("slide state changed to PREVIEW_DONE, so busting mask for path cache key");
                this.setState({
                    maskForPathCacheBusterKey: (new Date()).getTime(),
                });
            }
        }
        if ((prevProps.uiBusy || {}).status === true
            && (this.props.uiBusy || {}).status === false) {
            this.setState({
                isFetching: false,
            })
        }
        if ((this.state.cassetteSize === 1 || this.state.cassetteSize === 2) &&
            prevProps.previews[0] !== undefined && this.props.previews[0] !== undefined &&
            prevProps.previews[0].status !== this.props.previews[0].status && this.props.previews[0].status === RegionSelectionConstants.CONFIRMED) {
            this.onStartScanning();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return comparePropsAndState(this.props, nextProps, this.state, nextState);
    }

    componentWillUnmount() {
        console.log("SINGLE CASSETTE UNMOUNTING");
    }

    updateLoadingStatus = (index, val) => {
        let loadingStatus = this.state.slideLoadingStatus;
        if (this.props.selectedCassette in loadingStatus) {
            loadingStatus[this.props.selectedCassette][index] = val;
        } else {
            loadingStatus[this.props.selectedCassette] = {};
            loadingStatus[this.props.selectedCassette][index] = val;
        }
        this.setState({slideLoadingStatus: loadingStatus});
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    expandedSlideView = (slot_id) => {
        this.props.dispatch(updateEditorState(true))
        this.setState({
            selectedSlotIndex: slot_id,
            expandedSlide: true,
        });
    }

    closeExpadedSlideView = () => {
        this.props.dispatch(updateEditorState(false))
        this.setState({
            expandedSlide: false,
            maskForPathCacheBusterKey: (new Date()).getTime(),
        });
    }

    queueScan = (slideId, cassetteLevelScans) => {
        let {rack, tray} = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const callback = (resp) => {
            this.props.dispatch(getDeviceStatus(this.props.deviceId));
            this.props.dispatch(getC240Status());
        };

        if (cassetteLevelScans) {
            for (let i=0; i<6; i++) {
                const slideKey = this.props.selectedCassette + `S${i}`;
                const slideState = (this.props.slideLevelScanPreviewStatus[slideKey] || {}).slideState;
                let taskType = c240TaskType.TAKE_SCAN_OF_SELECTED_REGION;
                if (isNull(slideState) || slideState === C240SlideStatus.INITIAL) {
                    taskType = c240TaskType.DIRECT_SCAN;
                } else if(slideState === C240SlideStatus.PREVIEW_DONE) {
                    taskType = c240TaskType.TAKE_SCAN_OF_SELECTED_REGION;
                } else {
                    continue
                }
                setTimeout(() => {
                    appendToQueue(rack, tray, i, this.SlideType, taskType, queueActions.ADD, this.props.queueState, this.props.dispatch);
                }, 50)
            }
        } else {
            appendToQueue(rack, tray, slideId, this.SlideType, c240TaskType.TAKE_SCAN_OF_SELECTED_REGION, queueActions.ADD, this.props.queueState, this.props.dispatch);
        }

        queueScan(
            `?rack=${rack}&tray=${tray}&slide=${slideId}` +
            `&slide_type=${this.SlideType}&take_cassette_level_scan=${cassetteLevelScans}`, callback, false);

    }

    queuePreviewOnly = (slideId, cassetteLevelPreviews) => {
        // this.updatePreviewButtonStatus(slideId, true);
        let { rack, tray } = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const _this = this;
        const callback = (resp) => {
            console.log("UPdating")
            this.props.dispatch(getDeviceStatus(this.props.deviceId));
            this.props.dispatch(getC240Status());
        };

        if (cassetteLevelPreviews) {
            for (let i=0; i<6; i++) {
                setTimeout(() => {
                    appendToQueue(rack, tray, i, this.SlideType, c240TaskType.TAKE_SLIDE_PREVIEW, queueActions.ADD, this.props.queueState, this.props.dispatch);
                }, 50)
            }
        } else {
            appendToQueue(rack, tray, slideId, this.SlideType, c240TaskType.TAKE_SLIDE_PREVIEW, queueActions.ADD, this.props.queueState, this.props.dispatch);
        }

        callScannerServer("queue_preview",
            `?rack=${rack}&tray=${tray}&slide=${slideId}&slide_type=${this.SlideType}` +
            `&take_cassette_level_preview=${cassetteLevelPreviews}`,
            callback, false, callback);
    }

    render() {
        console.log("Loading status: ", this.state.slideLoadingStatus);
        const slideKey = this.props.selectedCassette + "S" + this.state.selectedSlotIndex;
        let slideLevelScanPreviewStatus = this.props.slideLevelScanPreviewStatus;
        let slideInfo = ((slideLevelScanPreviewStatus || {})[slideKey] || {}).previewResponse;
        let startPreview = getDummyPreviewObject(slideKey);
        let preview = getPreviewObject(slideKey, slideInfo, this.props.previewSlotsOnly[this.state.selectedSlotIndex]);
        const mySlideType = this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES ?
            slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;
        const trayKey = this.props.selectedCassette;
        let {rack, tray} = getRackTrayFromCassetteKey(trayKey);

        let slides = this.state.slotIndexes.map((index) => {
            let currSlideKey = this.props.selectedCassette + "S" + String(index);
            let singleSlideStatus = (slideLevelScanPreviewStatus || {})[currSlideKey];
            singleSlideStatus = singleSlideStatus !== undefined ? singleSlideStatus : startPreview;
            return <Row key={currSlideKey} style={{display: "flex", maxHeight: mySlideType === slideType.SLIDE_2_BY_3_INCH ? "800px" : "130px"}}
                        span={mySlideType === slideType.SLIDE_2_BY_3_INCH ? 8 : 4} align={'middle'} justify={'center'}
                        className={this.state.selectedSlotIndex === index && this.state.expandedSlide === true ? "active-slot" : ""}>
                <Col span={17}
                     style={{display: "flex", flexDirection: "row", justifyContent: "center", margin: "3px 0px"}}>
                    <C240SlideView
                        key={currSlideKey}
                        ref={this.slideElement[index]}
                        expandedSlide={this.state.expandedSlide}
                        expandedSlideView={this.expandedSlideView}
                        slotId={index}
                        highlightSlideKey={this.props.highlightSlideKey}
                        highlight={this.props.highlight}
                        mySlideType={mySlideType}
                        defaultConfig={this.state.defaultConfig}
                        cassetteKey={this.props.selectedCassette}
                        barcodeTaken={this.props.barcodeTaken}
                        slideState={(singleSlideStatus || {}).slideState}
                        slideStatus={singleSlideStatus}
                        deviceId={this.state.deviceId}
                        showLoading={(this.state.slideLoadingStatus[this.props.selectedCassette] || {})[index]}
                        slideInfo={((slideLevelScanPreviewStatus || {})[currSlideKey] || {}).previewResponse}
                        blockUI={this.props.blockUI}
                        maskForPathCacheBusterKey={this.state.maskForPathCacheBusterKey}/>
                </Col>
                <SlideActionColumn
                    key={currSlideKey}
                    index={index}
                    deviceId={this.props.deviceId}
                    slideStatus={singleSlideStatus}
                    queueState={this.props.queueState}
                    selectedCassette={this.props.selectedCassette}
                    barcodeVerify={this.state.barcodeVerify}
                    updateLoadingStatus={this.updateLoadingStatus}
                    CassetteType={this.props.CassetteType}
                />
            </Row>
        });

        const mockUseAllSlots = this.props.mockUseAllSlots === undefined ? false :
            this.props.mockUseAllSlots;
        return (
            <div
                className={this.props.currentProcessIndex !== progressStage.LOAD_SLIDES ?
                    "relative-position full-parent" : "relative-position full-parent blur"}>
                {this.state.expandedSlide ?
                    <Row className='c240-editing-pane full-parent'>
                        <SlideAreaSelectionComponent
                            id={this.state.selectedSlotIndex}
                            deviceId={this.props.deviceId}
                            defaultConfig={this.state.defaultConfig}
                            cassetteSize={this.state.cassetteSize}
                            startScanning={this.onStartScanning}
                            closeExpadedSlideView={this.closeExpadedSlideView}
                            preview={preview}
                            cassetteKey={this.props.selectedCassette}
                            onFinalizeSlideSettingsClick={this.props.onFinalizeSlideSettingsClick}
                            onFinalizedSlideSettings={this.props.onFinalizedSlideSettings}
                            slideType={mySlideType}
                            queueForScan={this.queueScan}
                        />
                    </Row>
                    :
                    <Row>
                        {
                            !mockUseAllSlots && this.props.isCassetteEmpty ?
                                <EmptyCassetteComponent mySlideType={mySlideType} rack={rack} tray={tray} />
                                :
                                <Col span={23}>
                                    <CassetteLevelActions
                                        selectedCassette={this.props.selectedCassette}
                                        status = {this.props.slideLevelScanPreviewStatus}
                                        queueForScan={this.queueScan} queueForPreview={this.queuePreviewOnly}
                                        mySlideType={mySlideType} />
                                    {slides}
                                </Col>
                        }
                    </Row>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const deviceStatus = state.deviceStatusReducer[ownProps.deviceId] || {};
    const scannerResponse =
        ((deviceStatus).scanner_health || {}).scanner_response || {};
    return {
        c240LoaderStatus: state.c240LoaderReducer,
        previewSlotsOnly: state.previewStatusReducer,
        mockUseAllSlots: (scannerResponse.mockConfig || {}).mockUseAllSlots,
        supportedSpecimenTypes: scannerResponse.supportedSpecimenTypes,
        verifyBarcode: ((deviceStatus).scanner_health || {}).verify_barcode,
        slideLevelScanPreviewStatus: scannerResponse.slideLevelScanPreviewStatus,
        uiBusy: deviceStatus.uiBusy
    };
};

export default connect(mapStateToProps)(SingleCassetteComponent);
